import * as types from './types';

const initialState = {
  getReviewSubmit: {},
  postReviewSubmit: {},
  getReopenReport: {}
};

export default function clientsReducer(state = initialState, action) {
  switch (action.type) {
    case 'RESET_KEY':
      return {
        ...state,
        [action.payload.key]: {}
      };

    case types.OVERNIGHT_CAMP_GET_REVIEW_SUBMIT_SUCCESS: {
      return {
        ...state,
        getReviewSubmit: action.payload
      };
    }
    case types.OVERNIGHT_CAMP_GET_REVIEW_SUBMIT_FAILURE:
      return { ...state, error: action.payload };

    case types.OVERNIGHT_CAMP_POST_REVIEW_AND_SUBMIT_SUCCESS: {
      return {
        ...state,
        postReviewSubmit: action.payload
      };
    }
    case types.OVERNIGHT_CAMP_POST_REVIEW_AND_SUBMIT_FAILURE:
      return { ...state, error: action.payload };

    case types.OVERNIGHT_CAMP_GET_REOPEN_SUCCESS: {
      return {
        ...state,
        getReopenReport: action.payload
      };
    }
    case types.OVERNIGHT_CAMP_GET_REOPEN_FAILURE:
      return { ...state, error: action.payload };

    default:
      return state;
  }
}
